import { STORAGE_KEYS } from 'app-constants'
import { getItem, setItem } from './sessionStorageUtils'

export function setIsDmaStorage(item) {
  setItem({
    itemName: STORAGE_KEYS.DMA,
    item,
  })
}

export function getIsDmaStorage() {
  return getItem({ itemName: STORAGE_KEYS.DMA })
}
